module.exports = __webpack_public_path__ + "img/avatar6.18afe7b6.png";